<template>
  <div v-if="items.length > 0" class="d-flex flex-column align-center justify-center">
    <div class="question-text mb-2">
      {{ questionText }}
    </div>
    <v-autocomplete
      v-model="answerId"
      :items="items"
      :attach="true"
      :menu-props="{
        allowOverflow: true,
        top: true,
        nudgeBottom: nudgeBottom
      }"
      dense
      filled
      rounded
      solo
      flat
      class="dropdown-input"
      item-text="text"
      item-value="id"
      hide-details
      placeholder="-- Selectati --"
      @change="selectAnswer"
    />
  </div>
</template>

<script>
export default {
  name: 'DropdownQuestion',
  props: {
    question: {
      type: Object,
      required: true
    },
    currentAnswer: {
      type: Object,
      default: null
    },
    parentAnswer: {
      type: Object,
      default: null
    },
    answers: {
      type: Array,
      default: () => []
    },
    roadTaxAnswer: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 110
    },
    isBottom: Boolean
  },
  data() {
    return {
      answerId: this.currentAnswer?.id || null
    };
  },
  computed: {
    items() {
      let options = [...this.question.options];
      if (this.parentAnswer && this.question.filterable) {
        options = options.filter(el => el.parentId === this.parentAnswer.id || !el.parentId);
      }
      options = options.filter((option) => {
        if (option.visibleIf) {
          const dependantAnswer = this.answers.find(el => el.questionId === option.visibleIf.questionId);
          if (dependantAnswer?.id !== option.visibleIf.answer) {
            return false;
          }
        }
        if (this.roadTaxAnswer === 1 && this.question.id === 3) {
          return !(option.id === 6);
        }
        return true;
      });
      return options;
    },
    questionText() {
      if (this.question?.parent === this.parentAnswer?.questionId && this.question.filterableText) {
        return this.question.filterableText.find(el => el.parentId === this.parentAnswer.id)?.text;
      }
      return this.question.text;
    }
  },
  watch: {
    parentAnswer() {
      this.answerId = null;
    },
    currentAnswer(newVal) {
      this.answerId = newVal?.id || null;
    }
  },
  methods: {
    selectAnswer() {
      const selected = this.question.options.find(el => el.id === this.answerId);
      if (selected) {
        selected.questionId = this.question.id;
        selected.questionText = this.questionText;
        selected.isBonus = this.question.isBonus || false;
        this.$emit('selectAnswer', selected);
      }
    }
  }
};
</script>

<style scoped>
.question-text {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}
.dropdown-input {
  border-radius: 4px !important;
  width: 355px;
}
.dropdown-input ::v-deep .v-select__slot input {
  border: none !important;
}
@media screen and (max-width: 600px) {
  .dropdown-input {
    width: 260px !important;
  }
}
</style>
